import { LICENSE_MODULES, ROLES } from '../../../../../constants';

import ContactDetails from '../../v2/components/avg/contact-details';
import Suppliers from '../../v2/components/avg/suppliers';
import UserActivityLog from '../../v2/components/avg/user-activity-log';
import CompanyStructure from '../../v2/components/avg/company-structure';
import ShiftPositions from '../../v2/components/avg/shift-positions';
import ShiftTemplate from '../../v2/components/avg/shift-template';
import ShiftDay from '../../v2/components/avg/shift-day';
import UpsertShiftTemplate from '../../v2/components/avg/shift-template/upsert';
import ShiftPlan from '../../v2/components/avg/shift-plans/shift-base';
import ChoosePlant from '../../v2/components/avg/shift-plans/choose-plant';
import TeamShiftPlan from '../../v2/components/avg/team-shift-plan';
import PlannedValues from '../../v2/components/avg/planned-values';
import FabricData from '../../v2/components/avg/fabricData';
import Metrics from '../../v2/components/avg/metrics';
import RMVA from '../../v2/components/avg/RMVA';
import TRAS from '../../v2/components/avg/TRAS';
import monthlyValues from '../../v2/components/avg/monthly-values';
import Calendar from '../../v2/components/avg/calendar';
import Year from '../../v2/components/avg/year';
import LogBook from '../../v2/components/avg/log-book';
import ShiftLog from '../../v2/components/avg/shift-log';
import AddShiftLog from '../../v2/components/avg/shift-log/upsert-shift-log';
import EditShiftLog from '../../v2/components/avg/shift-log/upsert-shift-log';
import Teams from '../../v2/components/avg/teams';
import TeamDetails from '../../v2/components/avg/teams/team-details';
import EnergieWate from '../../v2/components/avg/energie-wate';

export default [
  {
    path: '/',
    name: 'home-avg',
    redirect: '/avg/shift-plans',
    meta: {
      title: '',
      requiresAuth: true,
      module: LICENSE_MODULES.AVG,
      roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.SUPERUSER, ROLES.REPORTUSER],
    },
  },
  {
    path: '/avg/company-structure',
    name: 'Contact details',
    component: CompanyStructure,
    meta: {
      title: 'Company Structure',
      requiresAuth: true,
      module: LICENSE_MODULES.AVG,
      roles: [ROLES.SUPERADMIN],
    },
  },
  {
    path: '/avg/teams',
    name: 'teams',
    component: Teams,
    meta: {
      title: 'teams',
      requiresAuth: true,
      module: LICENSE_MODULES.AVG,
      roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.SUPERUSER],
    },
  },
  {
    path: '/avg/team-details/:id',
    name: 'team-details-avg',
    component: TeamDetails,
    meta: {
      title: 'Team Details',
      requiresAuth: true,
      module: LICENSE_MODULES.AVG,
      roles: '*',
    },
  },
  {
    path: '/avg/create-team',
    name: 'create-team-avg',
    component: TeamDetails,
    meta: {
      title: 'Create Team',
      requiresAuth: true,
      module: LICENSE_MODULES.AVG,
      roles: '*',
      isGoBackBtn: true,
    },
  },
  {
    path: '/avg/contact-details',
    name: 'Contact details',
    component: ContactDetails,
    meta: {
      title: 'Contact details',
      requiresAuth: true,
      module: LICENSE_MODULES.AVG,
      roles: [ROLES.SUPERADMIN],
    },
  },
  {
    path: '/avg/suppliers',
    name: 'Suppliers',
    component: Suppliers,
    meta: {
      title: 'Suppliers',
      requiresAuth: true,
      module: LICENSE_MODULES.AVG,
      roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.SUPERUSER],
    },
  },
  {
    path: '/avg/user-activity-log',
    name: 'UserActivityLog',
    component: UserActivityLog,
    meta: {
      title: 'User Activity Log',
      requiresAuth: true,
      module: LICENSE_MODULES.AVG,
      roles: [ROLES.SUPERADMIN, ROLES.ADMIN],
    },
  },
  {
    path: '/avg/shift-positions',
    name: 'Shift Positions',
    component: ShiftPositions,
    meta: {
      title: 'Shift Positions',
      requiresAuth: true,
      module: LICENSE_MODULES.AVG,
      roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.SUPERUSER],
    },
  },
  {
    path: '/avg/shift-log',
    name: 'Shift Log',
    component: ShiftLog,
    meta: {
      title: 'Shift Log',
      requiresAuth: true,
      module: LICENSE_MODULES.AVG,
      roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.SUPERUSER],
    },
  },
  {
    path: '/avg/planned-values',
    name: 'Planned Values',
    component: PlannedValues,
    meta: {
      title: 'Planned Values',
      requiresAuth: true,
      module: LICENSE_MODULES.AVG,
      roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.SUPERUSER, ROLES.REPORTUSER],
    },
  },
  {
    path: '/avg/fabric-data',
    name: 'Fabric Data',
    component: FabricData,
    meta: {
      title: 'Fabric Data',
      requiresAuth: true,
      module: LICENSE_MODULES.AVG,
      roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.SUPERUSER],
    },
  },
  {
    path: '/avg/metrics',
    name: 'Metrics',
    component: Metrics,
    meta: {
      title: 'Metrics',
      requiresAuth: true,
      module: LICENSE_MODULES.AVG,
      roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.SUPERUSER],
    },
  },
  {
    path: '/avg/RMVA',
    name: 'RMVA',
    component: RMVA,
    meta: {
      title: 'RMVA',
      requiresAuth: true,
      module: LICENSE_MODULES.AVG,
      roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.REPORTUSER, ROLES.USER, ROLES.SUPERUSER],
    },
  },
  {
    path: '/avg/monthly-values',
    name: 'monthly-values',
    component: monthlyValues,
    meta: {
      title: 'Monthly values',
      requiresAuth: true,
      module: LICENSE_MODULES.AVG,
      roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.REPORTUSER, ROLES.USER, ROLES.SUPERUSER],
    },
  },
  {
    path: '/avg/TRAS',
    name: 'TRAS',
    component: TRAS,
    meta: {
      title: 'TRAS',
      requiresAuth: true,
      module: LICENSE_MODULES.AVG,
      roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.REPORTUSER, ROLES.USER, ROLES.SUPERUSER],
    },
  },
  {
    path: '/avg/year',
    name: 'Year',
    component: Year,
    meta: {
      title: 'Years',
      requiresAuth: true,
      module: LICENSE_MODULES.AVG,
      roles: [ROLES.SUPERADMIN, ROLES.ADMIN],
    },
  },
  {
    path: '/avg/calendar',
    name: 'Calendar',
    component: Calendar,
    meta: {
      title: 'Calendar',
      requiresAuth: true,
      module: LICENSE_MODULES.AVG,
      roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.REPORTUSER, ROLES.USER, ROLES.SUPERUSER],
    },
  },
  {
    path: '/avg/energie-wate',
    name: 'EnergieWate',
    component: EnergieWate,
    meta: {
      title: 'Energiewerte',
      requiresAuth: true,
      module: LICENSE_MODULES.AVG,
      roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.REPORTUSER, ROLES.USER, ROLES.SUPERUSER],
    },
  },
  {
    path: '/avg/log-book',
    name: 'Log Book',
    component: LogBook,
    meta: {
      title: 'Log Book',
      requiresAuth: true,
      module: LICENSE_MODULES.AVG,
      roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.REPORTUSER, ROLES.USER, ROLES.SUPERUSER],
    },
  },
  {
    path: '/avg/add-shift-log',
    name: 'Add Shift Log',
    component: AddShiftLog,
    meta: {
      title: 'Add Shift Log',
      requiresAuth: true,
      module: LICENSE_MODULES.AVG,
      roles: '*',
      isGoBackBtn: true,
    },
  },
  {
    path: '/avg/edit-shift-log/:id',
    name: 'edit-shift-log',
    component: EditShiftLog,
    meta: {
      title: 'Edit Shift Log',
      requiresAuth: true,
      module: LICENSE_MODULES.AVG,
      roles: '*',
    },
  },
  {
    path: '/avg/shift-template',
    name: 'shift-template',
    component: ShiftTemplate,
    meta: {
      title: 'Shift Template',
      requiresAuth: true,
      module: LICENSE_MODULES.AVG,
      roles: [ROLES.SUPERADMIN, ROLES.ADMIN],
    },
  },
  {
    path: '/avg/new-shift-template',
    name: 'new-shift-template',
    component: UpsertShiftTemplate,
    meta: {
      title: 'Shift Template',
      requiresAuth: true,
      module: LICENSE_MODULES.AVG,
      roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.SUPERUSER],
      isGoBackBtn: true,
    },
  },
  {
    path: '/avg/shift-day',
    name: 'shift-day',
    component: ShiftDay,
    meta: {
      title: 'Shift Day',
      requiresAuth: true,
      module: LICENSE_MODULES.AVG,
      roles: '*',
      isGoBackBtn: true,
    },
  },
  {
    path: '/avg/edit-shift-template/:id',
    name: 'edit-shift-template',
    component: UpsertShiftTemplate,
    meta: {
      title: 'Shift Template',
      requiresAuth: true,
      module: LICENSE_MODULES.AVG,
      roles: '*',
    },
  },
  {
    path: '/avg/shift-plans',
    name: 'Shift plans',
    component: ChoosePlant,
    meta: {
      title: 'Shift plans',
      requiresAuth: true,
      module: LICENSE_MODULES.AVG,
      roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.SUPERUSER, ROLES.USER],
    },
  },
  {
    path: '/avg/team-shift-plan/:teamId',
    name: 'Team shift plan',
    component: TeamShiftPlan,
    meta: {
      title: 'Team shift plan',
      requiresAuth: true,
      module: LICENSE_MODULES.AVG,
      roles: '*',
    },
  },
  {
    path: '/avg/shift-plans/:id',
    name: 'shift-plant',
    component: ShiftPlan,
    meta: {
      title: 'Shift Plan',
      requiresAuth: true,
      module: LICENSE_MODULES.AVG,
      roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.SUPERUSER, ROLES.REPORTUSER],
    },
  },
];
